const checkLocalNetworkAccess = async () => {
  try {
    const permissionStatus = await navigator.permissions.query({
      name: 'local-network-access',
    });

    return {
      state: permissionStatus.state,
      permissionStatus,
    };
  } catch (e) {
    return {
      state: 'unsupported',
      permissionStatus: null,
    };
  }
};

export { checkLocalNetworkAccess };
